import React from "react";
import GoogleMapEmbed from "@/library/components/maps/GoogleMapEmbed";

export default function Contact({ address, contactItems, Iframe }) {
  const addressInfo = address[0];

  return (
    <div className="max-w-7xl mx-auto p-4 md:my-12">
      <div className="flex flex-col items-center w-full">
        <div className="grid grid-cols-1 sml:grid-cols-3 md:grid-cols-3 gap-8 sml:gap-2 w-full">
          <div className="grid grid-col self-start text-textPrimary">
            <h2 className="font-bold mb-2 text-lg">{addressInfo.title}</h2>{" "}
            <p>{addressInfo.streetAddress}</p>
            <p>
              {addressInfo.postalCode}, {addressInfo.city}
            </p>
            <p>{addressInfo.country}</p>
          </div>

          <div className="grid grid-col self-start text-textPrimary mt-8 sml:col-span-2">
            <div className="grid grid-col sml:grid-cols-2 sml:gap-6">
              {contactItems.map((contact) => (
                <div key={contact._uid} className="grid grid-col  mb-4">
                  <h3 className="font-bold text-lg">{contact.name}</h3>{" "}
                  <p className="font-bold">{contact.title}</p>
                  <p>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
